import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import DropdownMenu from './dropdownMenu/DropdownMenu';
import DropdownMenuItem from './dropdownMenu/DropdownMenuItem';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import SvgStatusSLogo from '../svg/StatusSLogo';
import SvgCompactDoubleArrowIcon from '../svg/SvgCompactDoubleArrowIcon';
import SvgUserSolid from '../svg/UserSolid';

function SecondaryNav(props) {
  const location = useLocation();
  const currentLocation = location.pathname + location.search;
  const currentUser = props.currentUser;

  let userImage = (
    <div className="secondary-nav__user-image">
      <SvgUserSolid data-test="user-generic-image" />
    </div>
  );
  if (currentUser.photo && currentUser.photo.http_path) {
    userImage = (
      <img
        alt="Profile"
        className="secondary-nav__user-image"
        src={currentUser.photo.http_path}
        data-test="user-api-image"
      />
    );
  }

  return (
    <div className="dropdown-menu__container dropdown-menu__reset">
      <DropdownMenu
        data-test="secondary-nav-menu"
        reverseIcon={true}
        menuButton={
          <React.Fragment>
            <SvgCompactDoubleArrowIcon
              className="margin-right-10"
              height="10px"
              data-test="double-arrow"
            />
            <SvgStatusSLogo
              className="text-primary margin-5"
              height="40px"
              data-test="status-logo"
            />
          </React.Fragment>
        }>
        <div
          data-test="secondary-nav-info-container"
          className="secondary-nav__info-container text-small">
          {userImage}
          <FormattedMessage
            id="secondaryNav.loggedInText"
            defaultMessage="Logged in as:"
            description="Opens editing something"
          />
          <span>
            <strong>
              {currentUser.first_name} {currentUser.last_name}
            </strong>
          </span>
          <span>
            <FormattedMessage
              id="secondaryNav.userNameText"
              defaultMessage="Username:"
              description="Opens editing something"
            />
            <strong className="margin-left-5">{currentUser.username}</strong>
          </span>
        </div>
        <hr />
        <FormattedMessage
          id="secondaryNav.myProfileText"
          defaultMessage="My Profile"
          description="Opens editing something">
          {(txt) => (
            <Link to={`/myProfile/`} data-test="secondary-nav-profile-link">
              <DropdownMenuItem data-test="profile-link">
                {txt}
              </DropdownMenuItem>
            </Link>
          )}
        </FormattedMessage>
        <FormattedMessage
          id="secondaryNav.associatedDevicesText"
          defaultMessage="My Associated Devices"
          description="Opens editing something">
          {(txt) => (
            <Link
              to="/myProfile/?view=devices"
              data-test="secondary-nav-devices-link">
              <DropdownMenuItem data-test="devices-link">
                {txt}
              </DropdownMenuItem>
            </Link>
          )}
        </FormattedMessage>
        <FormattedMessage
          id="secondaryNav.preferencesText"
          defaultMessage="Preferences"
          description="Opens editing something">
          {(txt) => (
            <Link
              to="/myProfile/?view=staff"
              data-test="secondary-nav-preferences-link">
              <DropdownMenuItem data-test="preferences-link">
                {txt}
              </DropdownMenuItem>
            </Link>
          )}
        </FormattedMessage>
        <FormattedMessage
          id="secondaryNav.changePasswordText"
          defaultMessage="Change My Password"
          description="Opens editing something">
          {(txt) => (
            <Link
              to={`/users/${currentUser.id}/updatePassword`}
              state={{
                modal: true,
                previous: currentLocation,
              }}
              data-test="secondary-nav-update-password-link">
              <DropdownMenuItem data-test="password-link">
                {txt}
              </DropdownMenuItem>
            </Link>
          )}
        </FormattedMessage>
        <hr />
        <FormattedMessage
          id="secondaryNav.logoutLink"
          defaultMessage="Logout"
          description="Header link to log out of the system"
          data-test="logout-link-wrapper">
          {(txt) => (
            <Link to="/logout" data-test="header-logout-link">
              <DropdownMenuItem data-test="logout-link">{txt}</DropdownMenuItem>
            </Link>
          )}
        </FormattedMessage>
      </DropdownMenu>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
  };
};

export default connect(mapStateToProps)(SecondaryNav);
